var map = {
	"./en": 1096,
	"./en.json": 1096,
	"./fr": 1097,
	"./fr.json": 1097,
	"./strm-moneyroad-fr": 1098,
	"./strm-moneyroad-fr.json": 1098
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;


//////////////////
// WEBPACK FOOTER
// ./src/locales ^\.\/.*$
// module id = 272
// module chunks = 2